// @flow
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
// import GenerateReportButton from '../Buttons/GenerateReportButton'
import Loading from '../Icons/loading.gif'
import Paginate from '../Buttons/Paginate'
import './NotificationsTable.css'
import { shortenString } from '../stringUtils'
import InfoIcon from '../../Shared/Icons/icon-info-grey.svg'
import styled from 'styled-components'

type Props = {
  changeOffset: Function,
  toggleSort: Function,
  data: Array,
  fields: Array,
  page: number,
  totalNotifications: number,
  sort: String,
  // generateReportClick: Function,
  // status: String,
  title: String,
  showTooltip?: Boolean,
  tooltipText?: string,
  route?: String
}

const HeaderTitle = styled.span`
  float: left;
  font-size: 20px;
  padding: 17px 15px 25px 23px;
`

/** @const {number} titleMaxLength */
const titleMaxLength = 80

/**
 * Diplay for user table
 * @class
 * @extends Component
 */
class NotificationsTable extends Component<Props> {
  /** render function */
  render () {
    const fields = this.props.fields
    const headers = fields.map((field, index) => {
      return (<th
        id={this.props.sort.split(' ')[0] === field.ref ? 'selected' : ''}
        className={this.props.sort.split(' ')[0] === field.ref ? (this.props.sort.split(' ')[1] === 'DESC' ? 'downSort' : 'upSort') : ''}
        key={index}
        onClick={(e) => {
          e.preventDefault()
          if (field.ref === 'createdDate') this.props.toggleSort(field.ref)
        }
        }>
        <span>{field.title}</span>
      </th>)
    })
    const notifications = this.props.data.map((notification, i) => {
      if (notification.title === 'Loading') {
        return (<tr key={Math.random()}><td><img src={Loading} alt='Loading' /></td></tr>)
      } else if (notification.title === '') {
        return false // removes notifications from list that does not have title
      } else {
        return (
          <tr key={i}>{fields.map((field) => {
            if (field.ref === 'title') {
              const route = this.props.route || '/notification'
              return (<td key={field.ref}><Link to={{ pathname: route, search: '?id=' + notification._id + '&type=' + notification.notificationType }}>{notification[field.ref].length > titleMaxLength ? shortenString(notification[field.ref], titleMaxLength) : notification[field.ref]} </Link></td>)
            } else if (field.toMap) {
              return (<td key={field.ref}> {field.toMap(notification[field.ref]) || '--'}</td>)
            }
            return (
              <td key={field.ref}>{notification[field.ref] || '0'} </td>
            )
          })}</tr>
        )
      }
    })
    return (
      <div>
        <div className='table-wrapper'>
          <div className='NotificationsTable'>
            <div className='flex align-center'>
              <HeaderTitle>{this.props.title}</HeaderTitle>
              { this.props.showTooltip &&
                <div className='tooltip'>
                  <span><img className='icon-md' src={InfoIcon} alt={InfoIcon} /></span>
                  <span className='tooltipText'>{this.props.tooltipText}</span>
                </div>
              }
              {/* <GenerateReportButton status={this.props.status} generateReportClicked={this.props.generateReportClick} /> */}
            </div>
            <table>
              <thead><tr>{headers}</tr></thead>
              <tbody>
                {notifications}
              </tbody>
            </table>
          </div>
        </div>
        <Paginate changePage={(i) => this.props.changeOffset(i)} page={this.props.page} length={this.props.totalNotifications} />
      </div>
    )
  }
}
export default NotificationsTable
